import { render, staticRenderFns } from "./CommunitySelection.vue?vue&type=template&id=11f91fbc&scoped=true&"
import script from "./CommunitySelection.vue?vue&type=script&lang=js&"
export * from "./CommunitySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f91fbc",
  null
  
)

export default component.exports